// API configuration that works in both preview and production environments
const getApiBaseUrl = () => {
  // Check if we're in production (custom domain) or preview
  const hostname = window.location.hostname;
  
  // If on a custom domain (production), use same-origin API calls
  if (hostname === 'gettradeforgeapp.com' || hostname === 'www.gettradeforgeapp.com') {
    return '/api';
  }
  
  // If on emergent.host domain (production), use same-origin
  if (hostname.includes('.emergent.host')) {
    return '/api';
  }
  
  // Otherwise use the environment variable (preview/development)
  return `${process.env.REACT_APP_BACKEND_URL}/api`;
};

export const API = getApiBaseUrl();

// Helper to get auth headers for mobile browsers that block cookies
export const getAuthHeaders = () => {
  const token = localStorage.getItem('session_token');
  if (token) {
    return { 'Authorization': `Bearer ${token}` };
  }
  return {};
};

export default API;
